import React, { useEffect } from 'react';
import { connect } from 'react-redux';

const capitalize = {
  textTransform: 'capitalize'
}

const Career = ({changeNameOrCareerReducer, user}) => {

    useEffect(() => {}, [changeNameOrCareerReducer]);

    return (
        <div>
          <span style={capitalize}> { user.persona.profesionUI } </span> 
        </div>
    );
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    changeNameOrCareerReducer: state.changeNameOrCareerReducer,
  }
}

export default connect(mapStateToProps)(Career);
